import React, { Component } from "react";
import { MnemoLoading, Title, BoxInfo } from "components/misc";
import { dateHelper, networkErrorHelper } from "libs";
import { MTable } from "components/table";
import { Container, Row, Col } from "design-react-kit";
import { revisionService } from "libs/api/revisionService";
import { getCurrentRevisor } from "store/actions";
import { MInput } from "components/forms";
import { withRouter } from "react-router-dom";

class SecurityCertificates extends Component {
  state = {
    loading: true,
    rndKey: 0,
    payload: [],
    currentPayload: [],
    company: null,
  };
  //--- ---

  tableConfig = {
    columns: [
      { id: "index", Header: "#", Cell: ({ row }) => row.index + 1 },
      {
        id: "name",
        Header: "Nome",
        accessor: "name",
      },
      {
        id: "surname",
        Header: "Cognome",
        accessor: "surname",
      },
      {
        id: "registrationCode",
        Header: "Codice Registrazione",
        accessor: "registrationCode",
      },
      {
        id: "courseCode",
        Header: "Codice Corso",
        accessor: "courseCode",
      },
      {
        id: "email",
        Header: "Email",
        accessor: "email",
      },
      {
        id: "mobile",
        Header: "Telefono",
        accessor: "mobile",
      },
      {
        id: "link",
        Header: "Attestato",
        accessor: "fileId",
        Cell: (props) => {
          const fileId = props.value;

          if (fileId) {
            return (
              <a href={`${process.env.REACT_APP_API_URL}/lesson-activity-file/download/${fileId}`} target="_blank" rel="noopener noreferrer">
                Scarica
              </a>
            );
          }

          return "";
        },
      },
      {
        id: "fileUploadDate",
        Header: "Data caricamento",
        accessor: (row) => {
          return row.fileUploadDate ? dateHelper.toITDateTime(row.fileUploadDate) : "";
        },
      },
    ],
    actions: [],
  };

  //--- ---

  componentDidMount() {
    const { context } = this.props.match.params;
    const revisor = getCurrentRevisor(context);
    const company = revisor.competitionClass;

    this.setState({ company }, () => {
      this.loadRemote();
    });
  }

  loadRemote() {
    this.setState({ loading: true });

    const { activityType } = this.props.match.params;
    const { company } = this.state;

    const filter = {
      lessonType: "training",
      code: "attestatoSicurezza",
      company,
      activityType,
    };

    revisionService
      .listAllSecurityCertificatesCompany(filter)
      .then(({ data }) => {
        //--- start: prepare reactTable ---
        const items = [];
        Object.entries(data.payload.lessonActivities).forEach(([key, val]) => {
          items.push(val);
        });

        this.setState({
          loading: false,
          payload: items,
          currentPayload: items,
          rndKey: Math.floor(Math.random() * 1000 + 1),
        });
        //--- end: prepare reactTable ---
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        } else {
          this.setState({
            payload: [],
            currentPayload: [],
            rndKey: Math.floor(Math.random() * 1000 + 1),
            loading: false,
          });
        }
      });
  }

  onSearch = (value) => {
    const { payload } = this.state;

    if (value === "" || value.length === 0) {
      this.setState({ currentPayload: payload });
      return;
    }

    const lowerValue = value.toLowerCase();
    const filteredPayload = payload.filter((item) => {
      return (
        (item.courseCode && item.courseCode.toLowerCase().includes(lowerValue)) ||
        (item.name && item.name.toLowerCase().includes(lowerValue)) ||
        (item.surname && item.surname.toLowerCase().includes(lowerValue)) ||
        (item.email && item.email.toLowerCase().includes(lowerValue)) ||
        (item.registrationCode && item.registrationCode.toLowerCase().includes(lowerValue))
      );
    });

    this.setState({
      currentPayload: filteredPayload,
      rndKey: Math.floor(Math.random() * 1000 + 1),
    });
  };

  render() {
    const searchField = {
      id: "searchRevision",
      name: "searchRevision",
      label: "Cerca per nome, cognome, codice registrazione, corso o email",
      type: "text",
      className: "form-control",
      onKeyUp: (elm, value) => {
        this.onSearch(value);
      },
    };

    const { loading } = this.state;

    return (
      <>
        <Row>
          <Col md={12}>
            <Title subtitle="TFA XI ciclo">Tirocinio Diretto - Attestati sulla sicurezza</Title>
          </Col>
        </Row>

        <Row>
          <Col md={6} className="text-md-end">
            <MInput {...searchField} className="my-2" />
          </Col>
        </Row>
        <hr />
        <section className="my-5">
          {loading ? (
            <MnemoLoading></MnemoLoading>
          ) : (
            <>
              <Container>
                <MTable key={this.state.rndKey} tableData={this.state.currentPayload} tableConfig={this.tableConfig} />
              </Container>
            </>
          )}

          {this.state.currentPayload.length === 0 && (
            <BoxInfo key="nrp-1" className="my-3">
              <div className="small text-info">Non ci sono dati da mostrare.</div>
            </BoxInfo>
          )}
        </section>
      </>
    );
  }
}

export default withRouter(SecurityCertificates);
